import { Coverage } from './../../models/NetworkCoverage';
import { Injectable } from '@angular/core';
import { Constants } from '@co-assist/library';
import { environment } from 'environments/environment';
@Injectable({
    providedIn: 'root'
})
export class ImagesService {
    private imageFolder: string = 'assets/images/';
    constructor() { }

    getProfilePicture(profilePictureFileName: string): string {
        return `https://user-files-${environment.STAGE}.s3.eu-west-1.amazonaws.com/groupProfilePictures/${profilePictureFileName}`;
    }
    getDefaultProfilePicture(): string {
        return 'assets/images/logos/co-assist/co-assist-c.png';
    }
    getCALogo(): string {
        return "assets/images/logos/co-assist/Co-assist-logo-2.png"
    }
    getCELogo(): string {
        return `https://user-files-${environment.STAGE}.s3.eu-west-1.amazonaws.com/groupProfilePictures/ce-sans-quadrillage.jpeg`;
    }
    getAlert(alertType?: Constants.Alert.AlertType): string {
        return alertType ? `${this.imageFolder}logos/alerts/alert_${alertType}.png` : `${this.imageFolder}logos/alertStates/alert_ok.png`;
    }
    getModuleState(state: Constants.Module.ModuleState): string {
        return `${this.imageFolder}logos/moduleStates/${state}_module_state.png`;
    }
    getCoverageState(state: Coverage): string {
        switch (state) {
            case Coverage.OK:
                return 'assets/images/logos/moduleStates/ok_module_state.png';
            case Coverage.WEAK:
                return 'assets/images/logos/moduleStates/warning_module_state.png';
            case Coverage.KO:
                return 'assets/images/logos/moduleStates/issue_module_state.png';
        }
    }
    getDevice(deviceType: Constants.Entity.DeviceType): string {
        if (deviceType === Constants.Entity.DeviceType.ZEECDMINOLR) { return `assets/images/deviceType/UNKNOWN.png`; }
        return `assets/images/deviceType/${deviceType}.png`;
    }
    getEquipment(equipment: Constants.Option.OptionEquipment | 'none'): string {
        return equipment === 'none' ? 'assets/images/equipment/empty.svg' : `assets/images/equipment/${equipment}.jpg`;
    }
    getBracelet(file: string): string {
        return `${this.imageFolder}bracelet/${file}`;
    }
    getWatchDisplay(display: 'hands' | 'numeric' | 'numeric_ddmm'): string {
        return `${this.imageFolder}watchDisplay/${display}.jpg`;
    }
    getSettingsState(areUpToDate: boolean): string {
        return this.getModuleState(areUpToDate ? Constants.Module.ModuleState.Ok : Constants.Module.ModuleState.Warning);
    }
    getBattery(level: Constants.Module.BatteryLevel): string {
        switch (level) {
            case Constants.Module.BatteryLevel.High:
            case Constants.Module.BatteryLevel.Medium:
                return 'assets/images/logos/moduleStates/ok_module_state.png';
            case Constants.Module.BatteryLevel.Low:
                return 'assets/images/logos/moduleStates/warning_module_state.png';
            case Constants.Module.BatteryLevel.Critical:
                return 'assets/images/logos/moduleStates/issue_module_state.png';
            case Constants.Module.BatteryLevel.Unknown:
                return 'assets/images/logos/moduleStates/unknown_module_state.png';
        }
    }
    getConnectivity(value: Constants.Module.Connectivity): string {
        switch (value) {
            case Constants.Module.Connectivity.Connected:
                return 'assets/images/logos/moduleStates/ok_module_state.png';
            case Constants.Module.Connectivity.Disconnected:
                return 'assets/images/logos/moduleStates/issue_module_state.png';
            case Constants.Module.Connectivity.Unknown:
            default:
                return 'assets/images/logos/moduleStates/unknown_module_state.png';
        }
    }

    getPaymentBrand(brand: 'mastercard' | 'maestro' | 'visa' | 'sepa'): string {
        return `${this.imageFolder}logos/paymentBrands/${brand}.png`;
    }
    getWhatsAppImage() {
        return 'assets/images/whatsapp_grey_64x64.png';
    }
}
